import Views from "@/views";
import Layout from "@/components/Layouts/Index.vue";

/* Views */
const { Piar, PiarTabContent } = Views;

const collectionRouter = {
  path: "/piar",
  component: Layout,
  redirect: "dashboard",
  name: "",
  history: false,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "piar",
      name: "PiarData",
      component: Piar,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "piar-basic-data/:Id?",
      name: "PiarForm",
      component: PiarTabContent,
      hidden: true,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default collectionRouter;
